module.exports = __webpack_public_path__ + "static/media/ic_scroll_left.3a863455.svg";